import { Body, Header, Popup, Title } from '@calendly/ui/components/popup'

import { PreviewPanel } from './preview_panel'

export const PreviewModal = ({ isOpen, onClose }) => (
  <Popup size="large" isOpen={isOpen} onClose={onClose}>
    <Header>
      <Title>Preview</Title>
    </Header>
    <Body>
      <PreviewPanel />
    </Body>
  </Popup>
)
